// extracted by mini-css-extract-plugin
export default {"root":"bXIskYjUAdxw3AuVUCzM","actions":"Dt7IZmwH2n7zp7yqL52x","top-right":"IytBfMPjw1yR1DjzFu66","topRight":"IytBfMPjw1yR1DjzFu66","fs":"YRP365U44fC7dpIjXtZ9"};